import React from 'react';
import { Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/5">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          {/* Main Content */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
            {/* Brand */}
            <div data-testid="footer-logo">
              <h3 className="text-white font-black uppercase tracking-[0.35em] text-xl pl-[0.35em]">RAMZY</h3>
              <p className="text-white/60 text-sm uppercase tracking-[0.3em] pl-[0.3em] mt-1">Coaching</p>
            </div>

            {/* Contact */}
            <a 
              href="mailto:oudehramzy@gmail.com" 
              className="flex items-center gap-2 text-white/40 hover:text-white/60 transition-colors text-sm"
              data-testid="footer-email"
            >
              <Mail className="w-4 h-4" />
              oudehramzy@gmail.com
            </a>
          </div>

          {/* Bottom */}
          <div className="mt-6 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/30 text-xs">
              © {currentYear} Roar AI LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-xs">
              <a href="#privacy" className="text-white/30 hover:text-white/50 transition-colors">
                Privacy
              </a>
              <a href="#terms" className="text-white/30 hover:text-white/50 transition-colors">
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
